const displayRole = (user) => {
    let result;

    switch(user.role){
        case 'NURSE' :
            result = user.gender === 'm' ? "Infirmier labo" : 'Infirmière labo';
            break;
        case 'LIBERAL' :
            result = user.gender === 'm' ? "Infirmier libéral" : 'Infirmière libérale';
            break;
        case 'SAMPLER' :
            result = user.gender === 'm' ? "Préleveur" : 'Préleveuse';
            break;
        case 'BIOLOGIST' :
            result = user.gender === 'm' ? "Biologiste" : 'Biologiste';
            break;
        case 'TECHNICIAN' :
            result = user.gender === 'm' ? "Technicien" : 'Technicienne';
            break;
        case 'COMPUTER' :
            result = user.gender === 'm' ? "D.S.I." : 'D.S.I.';
            break;
        case 'SECRETARY' :
            result = user.gender === 'm' ? "Secrétaire" : 'Secrétaire';
            break;
        default:
            result = 'Inconnu';
            break;

    }

    return result;

};

export default displayRole